import axios from "axios"
import { createAuthExpiredError, createBusinessError, getResponseMessage, handleAuthExpired, isAuthExpiredCode, showBusinessError } from "../src/request/authExpired";

var instance = axios.create({
  baseURL: '/server', 
  // timeout: 10000,
  headers: {
      'Content-Type': 'application/json;charset=UTF-8;',
      'accessToken':sessionStorage.getItem('token')
  }
})


//请求拦截器 
instance.interceptors.request.use((config) => {
  // console.log(config)
  const token = sessionStorage.getItem('token');
  token && (config.headers.Authorization = token)
  if (config.method === 'POST') {
      config.data = JSON.stringify(config.data);
  }
  return config;
}, (error) =>
// 对请求错误做些什么
Promise.reject(error));

// 响应拦截器
instance.interceptors.response.use(res=>{
  if (isAuthExpiredCode(res.data.code)) {
    handleAuthExpired(getResponseMessage(res));
    return Promise.reject(createAuthExpiredError());
  }
  if (Number(res.data.code) !== 0) {
    showBusinessError(getResponseMessage(res));
    return Promise.reject(createBusinessError());
  }
  return res
},err=>{
  return Promise.reject(err)  //返回错误
})

export default instance;


